export default "__VITE_ASSET__2e5eb91f__"